<div class="process-table-scroll-container">
  <div class="process-table-container">
    <table mat-table [dataSource]="dataSource" matSort class="process-table">
      <!-- Coluna de Ações -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button matTooltip="Editar" (click)="editProcess(element)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Excluir" (click)="openConfirmDeleteDialog(element)">
            <mat-icon>delete</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Detalhes" (click)="openDetailsDialog(element)">
            <mat-icon>info</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Colunas da Tabela -->
      <ng-container matColumnDef="numeroProcesso">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>N. do Processo</th>
        <td mat-cell *matCellDef="let element" data-label="N. do Processo">{{ element.numeroProcesso }}</td>
      </ng-container>

      <ng-container matColumnDef="empresa">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Empresa</th>
        <td mat-cell *matCellDef="let element" data-label="Empresa">{{ element.empresa.nome }}</td>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
        <td mat-cell *matCellDef="let element" data-label="Descrição">{{ element.descricao }}</td>
      </ng-container>

      <ng-container matColumnDef="tema">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tema</th>
        <td mat-cell *matCellDef="let element" data-label="Tema">{{ element.nomeTipoProcesso }}</td>
      </ng-container>

      <ng-container matColumnDef="situacao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
        <td mat-cell *matCellDef="let element" data-label="Situação">{{ element.situacao }}</td>
      </ng-container>

      <ng-container matColumnDef="dataInclusao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Data de Inclusão</th>
        <td mat-cell *matCellDef="let element" data-label="Data de Inclusão">{{ element.dataInclusao | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <!-- Cabeçalho e Linhas da Tabela -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <!-- Mensagem de Nenhum Processo Encontrado -->
    <div *ngIf="!realDataLoaded && dataSource.data.length === 0" class="no-data-message">
      Nenhum processo encontrado.
    </div>

    <!-- Paginador -->
    <mat-paginator [length]="(processes$ | async)?.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  </div>
</div>